import { ExploreAugmentedAsset } from "../../../../common/api/decimal/common-types/manageAssets";
import useStandardAssetPopover from "./useStandardAssetPopover";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { PopoverLinkDescriptor } from "../cards/usePopoverLinks.ts";

export default function FirstPopoverItemButton({
  asset,
  className,
  alternateLabels = {},
}: {
  asset: ExploreAugmentedAsset;
  alternateLabels?: Partial<
    Record<PopoverLinkDescriptor, { label: string; ariaLabel: string }>
  >;
  className?: string;
}) {
  const { popoverLinks, renderPopoverLinkDependencies } =
    useStandardAssetPopover(asset);

  const action = popoverLinks[0];

  const { label, ariaLabel } = alternateLabels[action.descriptor] ?? {
    label: action.label,
    ariaLabel: action.label + " - " + asset.manageAsset.title,
  };

  return (
    <>
      <BaseLinkOrButton
        className={className}
        href={action.href}
        onClick={action.onClick}
        to={action.to}
        aria-label={ariaLabel}
      >
        {label}
      </BaseLinkOrButton>
      {renderPopoverLinkDependencies()}
    </>
  );
}
